"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemperaturePanelRotationControl = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _three = require("@react-spring/three");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _shared = require("../../../shared");
var _selectors = require("../../../redux/selectors");
var _constants = require("../../../utils/constants");
var _useGetDevicesByParams = require("../../../hooks/store/useGetDevicesByParams");
var _Types = require("../../../Types");
var _TemperaturePanel = require("./TemperaturePanel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ComponentTypes
} = _paulCorePackage.constants;
const TemperaturePanelRotationControl = _ref => {
  let {
    thingPDIDDevice,
    displayNameId,
    pipe: propsPipe = '',
    panelPosition = [0, -4, 0],
    panelProps = {},
    index = 0
  } = _ref;
  const {
    secondPosition = _constants.panelPosition.top
  } = panelProps;
  const activeCameraPerspective = (0, _reactRedux.useSelector)(_selectors.getActiveCameraPerspective);
  const is2D = activeCameraPerspective === _constants.CameraPerspective.TwoD;
  const {
    equipmentType
  } = (0, _useGetDevicesByParams.useGetDeviceByPdid)({
    thingPDIDDevice
  });
  const thisPipe = (0, _react.useMemo)(() => {
    const isPwhSup = equipmentType === ComponentTypes.PwhSupply;
    if (isPwhSup) return propsPipe; // if it is pwhSyp, we can have devices from htg part
    const {
      pipes: ariaPipes = []
    } = _constants.ariaReg.find(aria => aria.reg.test(equipmentType)) || {};
    const {
      pipe
    } = ariaPipes.find(pipeItem => pipeItem.reg.test(displayNameId)) || {};
    return pipe !== null && pipe !== void 0 ? pipe : propsPipe;
  }, [propsPipe, displayNameId, equipmentType]);

  // if it is second panel, we need to change position (if it is not the same type or circulation)
  const isSecond = propsPipe !== thisPipe || index > 0 && thisPipe === _constants.pipesTypes.circulation;
  const position = (0, _react.useMemo)(() => {
    if (isSecond) {
      switch (secondPosition) {
        case _constants.panelPosition.bottom:
          return [panelPosition[0], panelPosition[1] - _constants.verticalPipeSpacing, panelPosition[2]];
        case _constants.panelPosition.top:
          return [panelPosition[0], panelPosition[1] + _constants.verticalPipeSpacing, panelPosition[2]];
        case _constants.panelPosition.left:
          return [panelPosition[0], panelPosition[1] + 8, panelPosition[2] + 6];
        case _constants.panelPosition.right:
          return [panelPosition[0], panelPosition[1] + 5, panelPosition[2] - 6];
        default:
          return panelPosition;
      }
    }
    return panelPosition;
  }, [isSecond, panelPosition, secondPosition]);
  const {
    rotation
  } = (0, _three.useSpring)({
    rotation: [0, 0, is2D ? Math.PI / 4 : 0]
  });
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_three.animated.group, {
    rotation: rotation,
    position: [position[0] + 2, position[1], position[2]]
  }, /*#__PURE__*/_react.default.createElement(_shared.ShowContentWrap, {
    thingPDIDDevice: thingPDIDDevice,
    pipe: thisPipe
  }, /*#__PURE__*/_react.default.createElement(_TemperaturePanel.TemperaturePanel, {
    displayNameId: displayNameId,
    thingPDIDDevice: thingPDIDDevice
  }))), [thingPDIDDevice, displayNameId, thisPipe, position, rotation]);
};
exports.TemperaturePanelRotationControl = TemperaturePanelRotationControl;
TemperaturePanelRotationControl.propTypes = {
  thingPDIDDevice: _propTypes.default.string,
  displayNameId: _propTypes.default.number,
  pipe: _propTypes.default.oneOf(Object.values(_constants.pipesTypes)),
  panelPosition: _Types.VectorType,
  panelProps: _propTypes.default.shape({
    secondPosition: _propTypes.default.oneOf(Object.values(_constants.panelPosition))
  }),
  index: _propTypes.default.number
};
TemperaturePanelRotationControl.defaultProps = {
  panelPosition: [0, -4, 0]
};